import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const PageSection = styled.section`
  padding: 12rem 0 6rem;
  background-color: var(--bg-primary);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
`;

const BackgroundGlow = styled.div`
  position: absolute;
  top: 8%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.08) 0%, transparent 70%);
  z-index: 0;
  pointer-events: none;
`;

const ContentWrap = styled(motion.div)`
  position: relative;
  z-index: 1;
  max-width: 880px;
  margin: 0 auto;
  color: var(--text-secondary);

  h1 {
    color: var(--text-primary);
    font-size: clamp(2.25rem, 4vw, 3rem);
    font-weight: 700;
    margin-bottom: 1rem;
    line-height: 1.15;
  }

  .updated {
    color: var(--text-tertiary);
    font-size: 0.95rem;
    margin-bottom: 2.5rem;
    display: block;
  }

  h2 {
    color: var(--text-primary);
    font-size: 1.5rem;
    font-weight: 600;
    margin: 2.5rem 0 1rem;
    line-height: 1.3;
  }

  h3 {
    color: var(--text-primary);
    font-size: 1.15rem;
    font-weight: 600;
    margin: 1.75rem 0 0.75rem;
  }

  p {
    line-height: 1.8;
    margin-bottom: 1rem;
    font-size: 1.02rem;
  }

  ul {
    padding-left: 1.5rem;
    margin: 1rem 0 1.25rem;

    li {
      line-height: 1.8;
      margin-bottom: 0.4rem;
    }
  }

  a {
    color: var(--accent-primary);
    text-decoration: underline;
  }
`;

const LegalPage = ({ title, updated, children }) => {
  return (
    <PageSection>
      <BackgroundGlow />
      <div className="container">
        <ContentWrap
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1>{title}</h1>
          {updated && <span className="updated">Last updated: {updated}</span>}
          {children}
        </ContentWrap>
      </div>
    </PageSection>
  );
};

export default LegalPage;
